// Importa Vue Toastification
import Toast from "vue-toastification";
import "vue-toastification/dist/index.css";

// Cria a configuração do plugin
const options = {
  // opções de configuração
  timeout: 3000, // Define o tempo de exibição do toast para 3 segundos
  position: "bottom-center", // Define a posição global dos toasts
};

export default function (app) {
  app.use(Toast, options);
}

/*
position: Define onde na tela os toasts serão mostrados. O valor 'bottom-right' é uma escolha comum para não obstruir elementos críticos da interface do usuário, mas você pode escolher outras opções como 'top-right', 'top-left', 'bottom-left', 'top-center', 'bottom-center', ou 'center' dependendo da sua preferência ou necessidades de design.
*/
